export default {
  bank_account_status: 'Bank Account Status',
  delete_account: 'Delete Account',
  online_banking: 'Online Banking',
  confirm_delete: 'Confirm Deletion',
  bank_account_holder: 'Bank Account Holder',
  add_new_bank_account: 'Add New Bank Account',
  bank_account_list: 'Bank Account List',
  bank_wallet: 'Copy of Bank Passbook/E-wallet',
  cash_out_settng: 'Cash Out Settings',
  payment_account: 'Payment Account',
  withdrawal_period: 'Cash Out Period',
  next_cash_out_date: 'Next Cash Out Date',
  fixed_amount: 'Over Fixed Amount',
  offline_check: 'Offline (Check)',
  offline_cash: 'Offline (Cash)',
  thai_qr_payment: 'Thai QR Payment',
  qr_payment: 'QR Payment',
  payment_type: 'Payment Type',
  upload_receipt: 'Upload Receipt',
  upload_receipt_required: 'Upload Receipt(Required)',
  upload_receipt_tip: 'Upload up to 5 receipt images for your top up process.',
  balance_details: 'Balance Details',
  recharge_record: 'Top Up',
  withdraw_record: 'Cash Out',
  nsds_bill: 'NSDS Bill',
  Transfer_Record: 'Transfer',
  balance: 'Balance',
  reverse: 'Reverse',
  payee_information: 'Payee Information',
  select_bank: 'Select A Bank',
  top_up: 'Top Up',
  cash_out: 'Cash Out',
  cashout_fail: 'Cashout Fail',
  successfully_submit: 'Submitted Successfully!',
  successfully_cash_out: 'Successfully Cash Out',
  withdraw_success_tip: 'The withdrawal application has been submitted, waiting for the bank to process',
  recharge_success_tip: 'You also need to transfer money with your bank card.',
  thai_qr_tip_1: 'The topup order will expire in ',
  qr_tip_1: 'The topup order will expire in ',
  one_hour: '1 hour',
  thai_qr_tip_2: ',please make the payment as soon as possible',
  qr_tip_2: ',please make the payment as soon as possible',
  name: 'Name',
  account: 'Account',
  mobile: 'Mobile',
  total_amount: 'Total Amount',
  total_fee: 'Total Fee',
  total_count: 'Total Count',
  remark: 'Remark',
  related_merchants: 'Associated Merchant',
  transfer: 'Transfer',
  transfer_amount: 'Transfer Amount',
  transfer_time: 'Transfer Time',
  action_date: 'Action Date',
  action_type: 'Transfer Type',
  amount: 'Amount',
  deposit_no: 'Deposit No',
  associated_merchant_id: 'Associated Merchant ID',
  associated_merchant_name: 'Associated Merchant Name',
  transfer_in_merchant_no: 'Transfer In Merchant No',
  transfer_out_merchant_no: 'Transfer Out Merchant No',
  recharge_tip: 'Bank Transfer to this account and save the transfer ticket.',
  recharge_tip_2: 'Initiate bank transfer to this account. Save receipt',
  loan_amount: 'Payout Amount',
  loan_number: 'Payout Count',
  loan_fee: 'Payout Fee',
  loan_commission: 'Payout Commission',
  collection_amount: 'Payin Amount',
  collection_number: 'Payin Count ',
  collection_fee: 'Payin Fee',
  collection_commission: 'Payin Commission',
  total_loan_amount: 'Total Payout Amount',
  total_loan_number: 'Total Payout Count',
  total_loan_fee: 'Total Payout Fee',
  total_collection_amount: 'Total Payin Amount',
  total_collection_number: 'Total Payin Count ',
  total_collection_fee: 'Total Payin Fee',
  monthly_summary: 'This Monthly Summary',
  last_monthly_summary: 'Last Monthly Summary',
  real_time_settlement_amount: 'Real-time Settlement Amount',
  postpone_amount: 'Payin Settlement',
  frozen_amount: 'Frozen Amount',
  unfrozen_amount: 'Unfrozen Amount',
  summary_details: 'Summary',
  creation: 'Creation',
  submission: 'Submission',
  step: 'Step',
  bank_details: 'Bank Details',
  company_address: 'Company Address',
  enter_top_up_amount: 'Enter Top Up Amount',
  amount_details: 'Amount Details',
  transfer_details: 'Transfer Details',
  sender: 'Sender',
  receiver: 'Receiver',
  fee: 'Fee',
  transactions_summary: 'Transactions Summary',
  total_transaction_details: 'Total Transaction Details',
  filter_section: 'Filter Section',
  payin_transaction: 'Payin Transaction',
  payout_transaction: 'Payout Transaction',
  refund_transaction: 'Refund Transaction',
  loan_transaction: 'Loan Transaction',
  repayment_transaction: 'Repayment Transaction',
  timeline: 'Timeline',
  paid: 'Paid',
  description: 'Description',
  payin_details: 'Payin Details',
  payout_details: 'Payout Details',
  payin_created: 'Payin Created',
  payin_completed: 'Payin Completed',
  payout_created: 'Payout Created',
  payout_completed: 'Payout Completed',
  resend_notice: 'Resend Notice',
  download_details: 'Download Details',
  download_time: 'Download Time',
  payment_method_channel: 'Payment Channel',
  currency: 'Currency',
  transaction_currency: 'Transaction Currency',
  top_up_currency: 'Top-up Currency',
  usd_amount: 'USD Amount',
  php_amount: 'PHP Amount',
  mxn_amount: 'MXN Amount',
  abnormal_adjustment: 'Abnormal Adjustment',
  abnormal_adjustment_credit_balance: 'Abnormal Adjustment - Credit (Available Balance)',
  abnormal_adjustment_credit_frozen: 'Abnormal Adjustment - Credit (Frozen Balance)',
  abnormal_adjustment_debit_balance: 'Abnormal Adjustment - Debit (Available Balance)',
  abnormal_adjustment_debit_frozen: 'Abnormal Adjustment - Debit (Frozen Balance)',
  frozen_amount_balance: 'Frozen Balance',
  total_commission: 'Total Commission',
  commission: 'Commission',
  remitting_bank: 'Remitting Bank',
  remitting_account: 'Remitting Account',
  initiate_refund: 'Initiate Refund',
  full_refund: 'Full Refund',
  partial_refund: 'Partial Refund',
  refund_amount: 'Refund Amount',
  refunded_transaction_fee: 'Refunded Transaction Fee',
  refund_number: 'Refund Number',
  refund_details: 'Refund Details',
  loan_detail: 'Loan Detail',
  refund_amount_fail: 'Refund Amount Fail',
  settlement_status: 'Settlement Status',
  estimated_settlement_time: 'Estimated Settlement Time',
  actual_settlement_time: 'Actual Settlement Time',
  fail_reason: 'Fail Reason',
  back_to_balance: 'Back to Account Balance',
  recharge_step_1_title: ' Step 1: Select bank',
  recharge_step_2_title: 'Step 2: Cash In Details',
  cash_out_amount: 'Cash out Amount',
  top_up_amount: 'Top Up Amount',
  scan_qr_code: 'Scan QR Code',
  refresh: 'Refresh',
  proceed_to_payment: 'Proceed to Payment',
  cash_out_amount_should: 'Cash Out Amount ',
  minimum_cash_out_amount: 'Minimum Cash Out Amount',
  pending_for_settlement: 'Pending for settlement(T+1)',
  exchange_rate: 'Exchange Rate',
  buy_currency: 'Buy Currency',
  buy_amount: 'Buy Amount',
  sell_currency: 'Sell Currengcy',
  sell_amount: 'Sell Amount',
  destination_amount: 'Destination Amount',
  source_amount: 'Payment Amount',
  quote_id: 'Quote ID',
  exchange_transaction_id: 'Exchange Transaction ID',
  fx_transaction_type: 'FX Transaction Type',
  base_currency: 'Base Currency',
  quote_currency: 'Quote Currency',
  quote_time: 'Quote Time',
  quote_expiry_time: 'Quote Expiry Time',
  document_proof: 'Document',
  related_transactions: 'Related Transactions',
  fx_transfer_out_fee: 'FX Transfer Out Fee',
  fx_reversal_transfer_in_fee: 'FX Reversal Transfer In Fee',
  bill_details: 'Bill Details',
  split_receiver: 'Split Receivers',
  split_transaction_no: 'Split Transaction No',
  split_detail_transaction_no: 'Split Detail Transaction No',
  split_merchant_no_or_name: 'Split Merchant No/Name',
  receiver_type: 'Receiver Type',
  receiver_account: 'Receiver Account',
  transaction_no: 'Transaction No',
  split_merchant: 'Split Merchant',
  receiver_name: 'Receiver Name',
  split_amount: 'Split Amount',
  receiver_relation: 'Receiver Relation',
  relation_document: 'Relation Document',
  add_receiver: 'Add Receiver',
  edit_receiver: 'Edit Receiver',
  split_transaction_detail: 'Split Transaction Detail',
  customize: 'Customize Relation',
  uploaded: 'Uploaded',
  not_uploaded: 'Not Uploaded',
  account_location: 'Bank Account Location',
  account_location_local: 'Local',
  account_location_overseas: 'Overseas',
  bank_address: 'Bank Address',
  swift_code: 'SWIFT',
  bank_wallet_tooltip: 'Must include: account number, account name, and bank name',
  currency_required: 'Currency cannot be empty',
  account_location_required: 'Bank Account Location cannot be empty',
  bank_address_required: 'Please provide the bank\'s address',
  swift_code_required: 'Please provide the SWIFT code',
  bank_account_proof: 'Bank Account Proof',
  invoice_image: 'Invoice',
  nick_name: 'Nick Name',
  withdrawal_amount: 'Withdrawal Amount',
  amount_received: 'Received Amount',
  refresh_exchange_rate: 'Refresh exchange rate',
  refresh_exchange_rate_after: 'Refresh in {time}',
  withdraw_information_confirmation: 'Withdrawal Information Confirmation',
  confirm_cash_out_title: 'Confirm',
  confirm_cash_out_message: 'Are you sure to confirm this cash out?',
  confirm_cash_out_btn: 'Confirm',
  cancel_cash_out_btn: 'Cancel',
  withdraw_currency: 'Withdrawal Currency',
  arrive_currency: 'Received Currency',
  fee_currency: 'Fee Currency',
  card_verification_count: 'Account Validation Count',
  card_verification_fee: 'Account Validation Fee',
  card_verification_failed_fee_refund: 'Account Validation Failed Fee Refund',
  card_verification_list: 'Account Validation List',
  card_verification_details: 'Account Validation Details',
  card_verification_info: 'Account Validation',
  basic_info: 'Basic Information',
  time_info: 'Time Information',
  recipient_name: 'Recipient Name',
  bank_wallet_name: 'Bank/Wallet Name',
  verification_type: 'Verification Type',
  cardholder_real_name: 'Cardholder Real Name',
  transaction_id: 'Transaction Id',
  merchant_order_id: 'Merchant Order Id',
  account_no: 'Account No',
  account_bank_code: 'Account Bank Code',
  account_name: 'Account Name',
  account_status: 'Account Status',
  order_status: 'Order Status',
  failed_message: 'Failed Message',
  name_match_result: 'Name Match Result',
  account_type: 'Account Type',
  institute_transaction_id: 'Institute Transaction Id',
  institute_name: 'Institute Name',
  channel_name: 'Channel Name',
  validation_amount: 'Validation Amount',
  validation_currency: 'Validation Currency',
  fee_split: 'Fee Split',
  fee_split_currency: 'Fee Split Currency',
  account_validate_result: 'Account Validate Result',
  transaction_status: 'Transaction Status',
  card_verifying: 'Verifying',
  card_verification_success: 'Verification Success',
  card_verification_failed: 'Verification Failed',
  card_verification_cost: 'Validation Fee',
  // 账户类型
  account_type_bank: 'BANK',
  account_type_va: 'VA',
  account_type_ewallet: 'EWALLET',
  account_type_unknown: 'Unknown',
  // 失败信息
  failure_message: 'Failure Message',
  // 账号真实KYC状态
  account_kyc_result: 'Account Kyc Verify Status',
  // 账户姓名匹配结果标签
  account_name_match: 'MATCH',
  account_name_not_match: 'NOT_MATCH',
  account_name_unknown: 'UNKNOWN',
  // 账户验证结果标签
  account_validate_valid: 'VALID',
  account_validate_invalid: 'INVALID',
  account_validate_unknown: 'UNKNOWN',
  status_pending: 'Pending',
  status_success: 'Success',
  status_failed: 'Failed',
  account_actual_type: 'Account Actual Type',
  pos_machine_sn: 'POS Machine SN'
}
